import { PresentationBody } from './PresentationTemplateSelectionStep.Body';
import { PresentationFooter } from './PresentationTemplateSelectionStep.Footer';

export const PresentationTemplateSelectionStep = {
  Body: PresentationBody,
  Footer: PresentationFooter,
};
